/* ============================================================
   Encirco PPF Portal — ppf-coverage-gallery.js
   Kit pop-up: the image area at the top now shows the red
   coverage diagrams (Partial / Front End / Track Pack / Full)
   instead of the vehicle photos, and switches to the matching
   diagram whenever a coverage level is selected. The separate
   "areas covered" block under the options is hidden (see the
   <style> in the section that loads this file).

   Loaded as a small add-on after ppf-portal.js so the main
   portal script is untouched. To undo: remove the
   "ppf_gallery_patch" section from templates/collection.ppf-portal.json.
   ============================================================ */
(function () {
  'use strict';

  var BASE = 'https://cdn.shopify.com/s/files/1/0965/9377/2893/files/';
  var IMAGES = {
    partial: BASE + 'ppf-diagram-partial.png?v=1788817821',
    front:   BASE + 'ppf-diagram-front.png?v=1788817821',
    track:   BASE + 'ppf-diagram-track.png?v=1788817821',
    full:    BASE + 'ppf-diagram-full.png?v=1788817820'
  };
  var LABELS = {
    partial: 'Partial Front End',
    front:   'Front End',
    track:   'Front End Extended (Track Pack)',
    full:    'Full Coverage'
  };
  var ORDER = ['partial', 'front', 'track', 'full'];

  function sized(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function init() {
    var overlay = document.getElementById('ppf-moverlay');
    var gallery = document.getElementById('ppf-gallery');
    if (!overlay || !gallery) return;

    var img, prev, next, count, thumbs, thumbBtns = [];
    var ready = false;
    var current = 'front';

    // Replace the gallery elements with fresh copies the first time the pop-up opens.
    // (ppf-portal.js keeps references to the originals and keeps filling them with the
    // vehicle photos; swapping them out leaves those references pointing at nothing.)
    function swap(id, deep) {
      var old = document.getElementById(id);
      if (!old) return null;
      var copy = old.cloneNode(!!deep);
      old.parentNode.replaceChild(copy, old);
      return copy;
    }

    function activeKey() {
      var card = overlay.querySelector('.ppf-cov-card.active');
      var k = card && card.getAttribute('data-cov');
      return IMAGES[k] ? k : 'front';
    }

    function show(key) {
      if (!IMAGES[key]) return;
      current = key;
      gallery.style.display = 'block';
      img.src = sized(IMAGES[key], 1400);
      img.alt = LABELS[key] + ' — areas covered';
      count.textContent = LABELS[key];
      for (var i = 0; i < thumbBtns.length; i++) {
        thumbBtns[i].classList.toggle('active', ORDER[i] === key);
      }
    }

    function pick(key) {
      var card = overlay.querySelector('.ppf-cov-card[data-cov="' + key + '"]');
      if (card) card.click();   // runs the portal's own price update, then our listener shows the image
      else show(key);
    }

    function step(d) {
      var i = ORDER.indexOf(current);
      pick(ORDER[(i + d + ORDER.length) % ORDER.length]);
    }

    function setup() {
      if (ready) return;
      ready = true;

      img    = swap('ppf-gallery-img', false);
      prev   = swap('ppf-gallery-prev', true);
      next   = swap('ppf-gallery-next', true);
      count  = swap('ppf-gallery-count', false);
      thumbs = swap('ppf-gallery-thumbs', false);
      if (!img || !prev || !next || !count || !thumbs) return;

      prev.hidden = false; next.hidden = false; count.hidden = false; thumbs.hidden = false;
      thumbs.innerHTML = '';

      ORDER.forEach(function (key) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ppf-gthumb';
        b.title = LABELS[key];
        b.setAttribute('aria-label', 'Show ' + LABELS[key]);
        var im = document.createElement('img');
        im.src = sized(IMAGES[key], 200);
        im.alt = '';
        b.appendChild(im);
        b.addEventListener('click', function () { pick(key); });
        thumbs.appendChild(b);
        thumbBtns.push(b);
      });

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });

      // Selecting a coverage card switches the top image to match.
      overlay.querySelectorAll('.ppf-cov-card').forEach(function (card) {
        card.addEventListener('click', function () {
          var k = card.getAttribute('data-cov');
          if (IMAGES[k]) show(k);
        });
      });

      // Arrow keys step through coverage levels.
      document.addEventListener('keydown', function (e) {
        if (!overlay.classList.contains('open')) return;
        var tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        if (e.key === 'ArrowLeft')  step(-1);
        if (e.key === 'ArrowRight') step(1);
      });
    }

    function onOpen() {
      setup();
      if (!img) return;
      show(activeKey());
    }

    new MutationObserver(function () {
      if (overlay.classList.contains('open')) onOpen();
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
